export function validatePhoneNumber (rule, value, callback) {
  if (value) {
    const reg = /^1[356789]\d{9}$/
    if (reg.test(value)) return callback()
    else callback(new Error('请输入正确的手机号码'))
  }
  callback()
}
